import React, { useState } from 'react';
import {useRsvp} from "../context/RsvpContext";
import {Info} from "../types/info";
import ButtonsRow from "../components/ButtonsRow";
import DrinksComponent from "../components/DrinksComponent";
import TransportComponent from "../components/TransportComponent";
import LodgingComponent from "../components/LodgingComponent";
import { useLocation } from "react-router-dom";


type Page = 'drinks' | 'transport' | 'lodging';

const AlcoholPage: React.FC<Info> = ({transport=true, lodging=false}) => {
    const {rsvp} = useRsvp();
    const location = useLocation();
    const locationState = location.state as { lodging?: boolean; transport?: boolean } | null;
    let displayLodging = true;
    const getInitialPage = (): Page => {
        if (locationState?.lodging || lodging) return 'lodging';
        if (locationState?.transport || transport) return 'transport';
        return 'drinks';
    };

    const [activePage, setActivePage] = useState<Page>(getInitialPage());

    const headerButtons = [
        {text: 'Bebidas', action: () => setActivePage('drinks'), disabled: false},
        {text: 'Transporte', action: () => setActivePage('transport'), disabled: false},
        {text: 'Hospedaje', action: () => setActivePage('lodging'), disabled: false},
    ]

    if (rsvp?.invitado_especial) {
        headerButtons[2].disabled = true;
        displayLodging = false;
    }

    return (
        <div className="bg-[url('assets/images/GreenTile.png')] bg-center bg-repeat bg-size-[auto_200px]">
            <div className="md:max-w-[40svw] mx-auto">
                <div className="flex flex-col justify-center">
                    <ButtonsRow buttons={headerButtons} className="mt-20" display={displayLodging}
                                activeButton={headerButtons.find(b => b.action.toString().includes(activePage))?.text}/>
                    <div className="px-6">
                        {activePage === 'drinks' && <DrinksComponent onTransportClick={() => setActivePage('transport')} onLodgingClick={() => setActivePage('lodging')} showLodging={displayLodging}/>}
                        {activePage === 'transport' && <TransportComponent/>}
                        {(activePage === 'lodging' && !rsvp?.invitado_especial) && <LodgingComponent/>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlcoholPage;